export default __webpack_public_path__ + "static/media/icon_story_4.988efbe4.svg";